import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyPersonSearchWithDistanceAndSearchType, SimpleSearchEntity } from '@nk/data-entities-lib';
import { HighlightTextPipe } from '@nk/ui-lib';

@Component({
  selector: 'nk-company-person-search-option',
  imports: [TranslateModule, HighlightTextPipe],
  templateUrl: './company-person-search-option.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyPersonSearchOptionComponent {
  public selectedItemIndex = input<number | undefined>();
  public disableEnterKey = input<boolean>(false);
  public searchQuery = input<string>('');
  public item = input<CompanyPersonSearchWithDistanceAndSearchType | undefined>();
  public simpleSearchClickSelectOutput = output<SimpleSearchEntity>();
  public highlightText = computed(() => {
    const searchQuery = this.searchQuery();
    return searchQuery && searchQuery.length ? searchQuery.split(' ') : [];
  });

  public simpleSearchClickSelect(simpleSearchEntity: SimpleSearchEntity): void {
    this.simpleSearchClickSelectOutput.emit(simpleSearchEntity);
  }
}
